// libraries
import React from "react";

import { Route, Switch, BrowserRouter } from "react-router-dom";
import { HalfYearProvider } from "./contexts/halfYearContext";
import { YearProvider } from "./contexts/yearContext";
import { AuthProvider } from "./contexts/authContext";
import { PopUpProvider } from "./contexts/popUpContext";

import ControlPanel from "./components/control-panel/ControlPanel";
import ChangePasswordPage from "./components/account/ChangePasswordPage";
import MustChangePasswordGuard from "./components/common/MustChangePasswordGuard";
import Private from "./components/common/PrivateRoute";
import NotFound from "./components/common/NotFound";
import Prints from "./components/prints/routes";
import Login from "./components/login/Login";
import { resolveMisPathFromToken } from "./services/loginRedirect";

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <YearProvider>
          <HalfYearProvider>
            <PopUpProvider>
              <Switch>
                <Private path="/print" component={Prints} />
                <Private path="/mis/change-password" exact component={ChangePasswordPage} />
                <Private
                  path="/mis"
                  render={(props) => (
                    <MustChangePasswordGuard>
                      <ControlPanel {...props} />
                    </MustChangePasswordGuard>
                  )}
                />
                <Route path="/login" component={Login} />
                <Route
                  path="/"
                  exact
                  render={() => {
                    const token = localStorage.getItem("aria_token");
                    if (token) {
                      resolveMisPathFromToken(token).then((path) => {
                        window.location.replace(path);
                      });
                    } else {
                      window.location.replace("/login.html");
                    }
                    return null;
                  }}
                />
                <Private component={NotFound} />
              </Switch>
            </PopUpProvider>
          </HalfYearProvider>
        </YearProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
